import { IAverageTireTrendsResponse } from '../../interfaces/average-tire-trends.interface'
import { IAverageTrendResponse } from '../../interfaces/average-trends.interface'

export interface TrendReportsStateModel {
  trends: IAverageTrendResponse
  tireTrends: IAverageTireTrendsResponse
}
